import type { Origin } from "../../../api/types";
import { STATE_WORDS, type DisplayState } from "../../../ui/state";

/**
 * What to show for a state the server gave as text. The family tree and the history feed carry states as
 * plain strings; accepted and added by hand both wait for the SME (BUILD-PLAN 2.4.3). A withdrawn or removed
 * element is gone from the screens, so it has no look. A missing state on loaded content is "loaded".
 */
export function toDisplayState(state: string | null | undefined, origin: Origin = "work"): DisplayState | null {
  switch (state) {
    case "proposed":
      return "proposed";
    case "accepted":
    case "added_by_hand":
    case "waiting":
      return "waiting";
    case "validated":
      return "validated";
    case "sent_back":
      return "sent_back";
    case "rejected":
      return "rejected";
    case "loaded":
      return "loaded";
    case "withdrawn":
    case "removed":
      return null;
    default:
      return origin === "loaded" && !state ? "loaded" : null;
  }
}

/** True for a state that takes an element out of the screens. */
export function isGone(state: string | null | undefined): boolean {
  return state === "withdrawn" || state === "removed";
}

/** The states a person can filter by, in the order the counters list them. */
export const FILTER_STATES: readonly DisplayState[] = ["proposed", "waiting", "validated", "sent_back", "rejected", "loaded"];

export { STATE_WORDS };
export type { DisplayState };
